export default "__VITE_ASSET__CUW$Z7uL__"